export default "__VITE_ASSET__CpBhzTuN__"